import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import DownloadSampleApplicationAndroid from './tabs/sample-xdm-implementation/download-sample-application/android.md';
import DownloadSampleApplicationIos from './tabs/sample-xdm-implementation/download-sample-application/ios.md';
import BuildXDMObjectsAndroid from './tabs/sample-xdm-implementation/build-xdm-objects/android.md';
import BuildXDMObjectsIos from './tabs/sample-xdm-implementation/build-xdm-objects/ios.md';
import OverrideDefaultDatasetAndroid from './tabs/sample-xdm-implementation/override-default-dataset/android.md';
import OverrideDefaultDatasetIos from './tabs/sample-xdm-implementation/override-default-dataset/ios.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TabsBlock = makeShortcode("TabsBlock");
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "sample-xdm-implementation"
    }}>{`Sample XDM Implementation`}</h1>
    <h2 {...{
      "id": "prerequisites-for-this-tutorial"
    }}>{`Prerequisites for this tutorial`}</h2>
    <p>{`Before starting this tutorial, please read and follow the steps in the `}<a parentName="p" {...{
        "href": "./overview.md"
      }}>{`getting started with Adobe Experience Platform tutorial`}</a>{`.`}</p>
    <h3 {...{
      "id": "download-the-sample-application"
    }}>{`Download the sample application`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <DownloadSampleApplicationAndroid mdxType="DownloadSampleApplicationAndroid" />
    <p>{`iOS`}</p>
    <DownloadSampleApplicationIos mdxType="DownloadSampleApplicationIos" />
    <h3 {...{
      "id": "set-up-the-configuration"
    }}>{`Set up the configuration`}</h3>
    <p>{`In the `}<a parentName="p" {...{
        "href": "https://experience.adobe.com/#/data-collection/"
      }}>{`Data Collection UI`}</a>{`, go to the `}<strong parentName="p">{`Environments`}</strong>{` tab in the previously created mobile property and click on the Development icon (`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "24px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "112.5%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/client-sdks/static/7c534fd570c081dfd8c36016b8862f6f/ad722/development-icon.webp 24w"],
            "sizes": "(max-width: 24px) 100vw, 24px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/client-sdks/static/7c534fd570c081dfd8c36016b8862f6f/22424/development-icon.png 24w"],
            "sizes": "(max-width: 24px) 100vw, 24px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/client-sdks/static/7c534fd570c081dfd8c36016b8862f6f/22424/development-icon.png",
            "alt": "img",
            "title": "img",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span>{`). Find the Environment File ID at the top and copy it.`}</p>
    <p>{`Set the `}<inlineCode parentName="p">{`LAUNCH_ENVIRONMENT_FILE_ID`}</inlineCode>{` to the copied Environment File ID in the `}<inlineCode parentName="p">{`MainApp`}</inlineCode>{` (Android) / `}<inlineCode parentName="p">{`AppDelegate`}</inlineCode>{` (iOS) class.`}</p>
    <h2 {...{
      "id": "create-schema-and-dataset-for-product-reviews"
    }}>{`Create schema and dataset for product reviews`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`In the browser, navigate to `}<a parentName="p" {...{
            "href": "https://experience.adobe.com/platform"
          }}>{`Adobe Experience Platform`}</a>{` and login with your credentials.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Create an `}<a parentName="p" {...{
            "href": "https://experienceleague.adobe.com/docs/experience-platform/xdm/tutorials/create-schema-ui.html"
          }}>{`XDM Schema`}</a>{` as follows:`}</p>
        <ul parentName="li">
          <li parentName="ul">
            <p parentName="li">{`From the left panel, select `}<strong parentName="p">{`Schemas`}</strong></p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Select `}<strong parentName="p">{`Create schema`}</strong>{`, followed by `}<strong parentName="p">{`XDM ExperienceEvent`}</strong></p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Set the name for this schema as "Product Reviews".`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Select the `}<strong parentName="p">{`Add`}</strong>{` button (+) to add field groups`}</p>
            <ul parentName="li">
              <li parentName="ul">{`Select `}<strong parentName="li">{`Environment Details`}</strong>{` from the "Use existing field groups" section then select `}<strong parentName="li">{`Add field group`}</strong>{`.`}</li>
            </ul>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Select the `}<strong parentName="p">{`Add`}</strong>{` button (+) to add field groups`}</p>
            <ul parentName="li">
              <li parentName="ul">{`Select `}<strong parentName="li">{`Create new field group`}</strong>{` and set the name as "Product review", then select `}<strong parentName="li">{`Add field group`}</strong>{`.`}</li>
            </ul>
          </li>
          <li parentName="ul">
            <p parentName="li">{`In the Schema structure, select the "Product review" field group and select the plus icon (+) next to the schema name "Product Reviews".`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Start adding fields as follows. After each, select `}<strong parentName="p">{`Apply`}</strong>{`, then plus icon (+) to add the next field.`}</p>
            <table parentName="li">
              <thead parentName="table">
                <tr parentName="thead">
                  <th parentName="tr" {...{
                    "align": "left"
                  }}>{`Field name`}</th>
                  <th parentName="tr" {...{
                    "align": "left"
                  }}>{`Display name`}</th>
                  <th parentName="tr" {...{
                    "align": "left"
                  }}>{`Type`}</th>
                  <th parentName="tr" {...{
                    "align": "left"
                  }}>{`Required`}</th>
                </tr>
              </thead>
              <tbody parentName="table">
                <tr parentName="tbody">
                  <td parentName="tr" {...{
                    "align": "left"
                  }}>{`productSku`}</td>
                  <td parentName="tr" {...{
                    "align": "left"
                  }}>{`Product SKU`}</td>
                  <td parentName="tr" {...{
                    "align": "left"
                  }}>{`String`}</td>
                  <td parentName="tr" {...{
                    "align": "left"
                  }}>{`Yes`}</td>
                </tr>
                <tr parentName="tbody">
                  <td parentName="tr" {...{
                    "align": "left"
                  }}>{`reviewText`}</td>
                  <td parentName="tr" {...{
                    "align": "left"
                  }}>{`Review Text`}</td>
                  <td parentName="tr" {...{
                    "align": "left"
                  }}>{`String`}</td>
                  <td parentName="tr" {...{
                    "align": "left"
                  }}>{`No`}</td>
                </tr>
                <tr parentName="tbody">
                  <td parentName="tr" {...{
                    "align": "left"
                  }}>{`rating`}</td>
                  <td parentName="tr" {...{
                    "align": "left"
                  }}>{`Rating`}</td>
                  <td parentName="tr" {...{
                    "align": "left"
                  }}>{`Integer`}</td>
                  <td parentName="tr" {...{
                    "align": "left"
                  }}>{`Yes`}</td>
                </tr>
                <tr parentName="tbody">
                  <td parentName="tr" {...{
                    "align": "left"
                  }}>{`reviewerId`}</td>
                  <td parentName="tr" {...{
                    "align": "left"
                  }}>{`Reviewer ID`}</td>
                  <td parentName="tr" {...{
                    "align": "left"
                  }}>{`String`}</td>
                  <td parentName="tr" {...{
                    "align": "left"
                  }}>{`Yes`}</td>
                </tr>
              </tbody>
            </table>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Select the `}<inlineCode parentName="p">{`reviewerId`}</inlineCode>{` and enable it for Identity , enable `}<strong parentName="p">{`Primary Identity`}</strong>{` and select Identity namespace "Email".`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Select `}<strong parentName="p">{`Save`}</strong>{`.`}</p>
          </li>
        </ul>
      </li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "53.75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/client-sdks/static/e970cbb3363e81d96a2b3f407b2be2e3/5530d/xdm-product-review.webp 320w", "/client-sdks/static/e970cbb3363e81d96a2b3f407b2be2e3/0c8fb/xdm-product-review.webp 640w", "/client-sdks/static/e970cbb3363e81d96a2b3f407b2be2e3/94b1e/xdm-product-review.webp 1280w", "/client-sdks/static/e970cbb3363e81d96a2b3f407b2be2e3/0b34d/xdm-product-review.webp 1920w", "/client-sdks/static/e970cbb3363e81d96a2b3f407b2be2e3/d5269/xdm-product-review.webp 2560w", "/client-sdks/static/e970cbb3363e81d96a2b3f407b2be2e3/6e85c/xdm-product-review.webp 3584w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/client-sdks/static/e970cbb3363e81d96a2b3f407b2be2e3/dd4a7/xdm-product-review.png 320w", "/client-sdks/static/e970cbb3363e81d96a2b3f407b2be2e3/0f09e/xdm-product-review.png 640w", "/client-sdks/static/e970cbb3363e81d96a2b3f407b2be2e3/bbbf7/xdm-product-review.png 1280w", "/client-sdks/static/e970cbb3363e81d96a2b3f407b2be2e3/ac7a9/xdm-product-review.png 1920w", "/client-sdks/static/e970cbb3363e81d96a2b3f407b2be2e3/c7a69/xdm-product-review.png 2560w", "/client-sdks/static/e970cbb3363e81d96a2b3f407b2be2e3/ed6ae/xdm-product-review.png 3584w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/client-sdks/static/e970cbb3363e81d96a2b3f407b2be2e3/bbbf7/xdm-product-review.png",
            "alt": "xdm product review",
            "title": "xdm product review",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`The previously created schema wil be used for the profiles you are about to create.`}
        <ul parentName="li">
          <li parentName="ul">{`Select the Schema name, then from the right panel enable the `}<strong parentName="li">{`Profile`}</strong>{` toggle.`}</li>
          <li parentName="ul">{`When the `}<strong parentName="li">{`Enable for Profile`}</strong>{` pop-up is displayed, select `}<strong parentName="li">{`Enable`}</strong>{`.`}</li>
        </ul>
      </li>
      <li parentName="ol">{`Create a dataset for the schema:`}
        <ul parentName="li">
          <li parentName="ul">{`Select `}<strong parentName="li">{`Datasets`}</strong>{` from the left panel, followed by `}<strong parentName="li">{`Create dataset`}</strong>{` and `}<strong parentName="li">{`Create dataset from schema`}</strong>{`.`}</li>
          <li parentName="ul">{`Search for the previously created "Product Reviews" schema and select it.`}</li>
          <li parentName="ul">{`Select `}<strong parentName="li">{`Next`}</strong>{` and name the dataset "Product Reviews", followed by selecting `}<strong parentName="li">{`Finish`}</strong>{`.`}</li>
        </ul>
      </li>
      <li parentName="ol">{`Finally, you will want to include this dataset with Real-time Customer Profile:`}
        <ul parentName="li">
          <li parentName="ul">{`Select the previously created "Product Reviews" dataset.`}</li>
          <li parentName="ul">{`From the right panel, enable the `}<strong parentName="li">{`Profile`}</strong>{` toggle.`}</li>
        </ul>
      </li>
    </ol>
    <h2 {...{
      "id": "send-product-review"
    }}>{`Send product review`}</h2>
    <h3 {...{
      "id": "build-xdm-objects"
    }}>{`Build XDM objects`}</h3>
    <p>{`You can now implement the product review functionality in the sample application. Navigate to `}<inlineCode parentName="p">{`EdgeViewController.swift`}</inlineCode>{` (iOS) / `}<inlineCode parentName="p">{`EdgeTab.java`}</inlineCode>{` (Android) and implement the `}<inlineCode parentName="p">{`sendProductReviewXdmEvent`}</inlineCode>{` function.`}</p>
    <ol>
      <li parentName="ol">{`Create the XDM Experience Event using the `}<inlineCode parentName="li">{`XDM IdentityMap`}</inlineCode>{` containing the reviewer `}<inlineCode parentName="li">{`Email`}</inlineCode>{` and the review information.`}</li>
    </ol>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <BuildXDMObjectsAndroid mdxType="BuildXDMObjectsAndroid" />
    <p>{`iOS`}</p>
    <BuildXDMObjectsIos mdxType="BuildXDMObjectsIos" />
    <p><strong parentName="p">{`Note:`}</strong>{` When sending XDM data for custom field groups, use your `}<strong parentName="p">{`_tenantId`}</strong>{` as shown in the schema.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`Use the knowledge from Assignment 1 and connect to an Assurance Session to verify if the XDM data sent from the sample app is in the correct format.`}</p>
    <h3 {...{
      "id": "override-the-default-dataset"
    }}>{`Override the default dataset`}</h3>
    <ol>
      <li parentName="ol">{`Send the Experience Event using the Adobe Experience Platform Edge extension and specify the dataset identifier for "Product Reviews".`}
        <ul parentName="li">
          <li parentName="ul">{`Copy the `}<inlineCode parentName="li">{`<DatasetIdentifier>`}</inlineCode>{` from the "Product Reviews" dataset in Platform and replace it in the sample app implementation where indicated below.`}</li>
        </ul>
      </li>
    </ol>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <OverrideDefaultDatasetAndroid mdxType="OverrideDefaultDatasetAndroid" />
    <p>{`iOS`}</p>
    <OverrideDefaultDatasetIos mdxType="OverrideDefaultDatasetIos" />
    <h3 {...{
      "id": "run-the-sample-application"
    }}>{`Run the sample application`}</h3>
    <p>{`Run the sample app on a device or simulator in Xcode / Android Studio. Click on the `}<inlineCode parentName="p">{`Edge`}</inlineCode>{` tab and start testing the Product Review implementation.`}</p>
    <ol>
      <li parentName="ol">{`Select a Product from the list.`}</li>
      <li parentName="ol">{`In the "XDM Product Review Example" section:`}
        <ul parentName="li">
          <li parentName="ul">{`Fill in the `}<strong parentName="li">{`Reviewer email`}</strong>{` with a sample email address.`}</li>
          <li parentName="ul">{`Add the rating for the selected product.`}</li>
          <li parentName="ul">{`Write your comment.`}</li>
          <li parentName="ul">{`Click `}<strong parentName="li">{`Submit Review`}</strong>{`.`}</li>
        </ul>
      </li>
      <li parentName="ol">{`Repeat these steps multiple times to "collect" product reviews.`}</li>
    </ol>
    <h2 {...{
      "id": "view-the-product-reviews-in-adobe-experience-platform"
    }}>{`View the product reviews in Adobe Experience Platform`}</h2>
    <p>{`After using the sample demo application to send product reviews as XDM Experience Events, query the data in Adobe Experience Platform.`}</p>
    <p><strong parentName="p">{`Note:`}</strong>{` It may take up to 15-20 minutes before the data shows up in Adobe Experience Platform.`}</p>
    <p>{`Query the dataset which stores the commerce data by doing the following:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Log in to `}<a parentName="p" {...{
            "href": "https://experience.adobe.com/platform"
          }}>{`Adobe Experience Platform`}</a>{` using your Adobe credentials.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select your Adobe Experience Cloud organization to the organization ID used to configure the demo application.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`On the navigation panel, under Data Management, select `}<strong parentName="p">{`Datasets`}</strong>{` and select the dataset you created at the beginning of this tutorial. From the right panel, copy the `}<inlineCode parentName="p">{`Table name`}</inlineCode>{` value.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`From the left panel, select `}<strong parentName="p">{`Queries`}</strong>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click the `}<strong parentName="p">{`Overview`}</strong>{` tab, then click `}<strong parentName="p">{`Create query`}</strong>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the text box, enter a SQL query against your dataset table. Here is an example:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-sql"
          }}>{`SELECT * FROM paste_your_table_name_here 
    WHERE eventType = 'product.review' LIMIT 10
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select the "Play" icon to run the query. The results will appear in the `}<strong parentName="p">{`Results`}</strong>{` tab at the bottom.`}</p>
      </li>
    </ol>
    <h2 {...{
      "id": "view-the-real-time-customer-profile"
    }}>{`View the Real-time Customer Profile`}</h2>
    <p>{`The customer profile can be viewed in `}<a parentName="p" {...{
        "href": "https://experience.adobe.com/platform"
      }}>{`Adobe Experience Platform`}</a>{`.`}</p>
    <ol>
      <li parentName="ol">{`Select `}<strong parentName="li">{`Profiles`}</strong>{` from the left panel.`}</li>
      <li parentName="ol">{`Select `}<strong parentName="li">{`Browse`}</strong>{` and search for the email you sent from the sample app.`}
        <ul parentName="li">
          <li parentName="ul">{`Select the merge policy `}<inlineCode parentName="li">{`_xdm.context.profile`}</inlineCode>{` Private graph Timestamp ordered`}</li>
          <li parentName="ul">{`Select "Email" as the identity namespace.`}</li>
          <li parentName="ul">{`For the identity value, enter the same email as you sent from the app.`}</li>
          <li parentName="ul">{`Select the Profile ID found in the table.`}</li>
        </ul>
      </li>
      <li parentName="ol">{`Inspect the customer profile.`}
        <ul parentName="li">
          <li parentName="ul">{`Notice that the client-side ECID and the email(s) you sent in XDM format using the Edge extension are now displayed in the Detail view, under the `}<strong parentName="li">{`Linked identities`}</strong>{` section, as well as in the `}<strong parentName="li">{`Attributes`}</strong>{` view.`}</li>
          <li parentName="ul">{`In the `}<strong parentName="li">{`Events`}</strong>{` tab you can view the events sent to the dataset(s) enabled for Profile for the selected customer profile.`}</li>
        </ul>
      </li>
    </ol>
    <p>{`To learn more about the Adobe Customer Profile, see the `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/experience-platform/identity/home.html"
      }}>{`Identity Service overview`}</a>{` and the `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/experience-platform/identity/namespaces.html"
      }}>{`Identity namespace overview`}</a>{`.`}</p>
    <h2 {...{
      "id": "extra-credit-create-audience-based-on-identity-authentication-state"
    }}>{`Extra credit: Create audience based on Identity Authentication State`}</h2>
    <p>{`Create an audience in `}<a parentName="p" {...{
        "href": "https://experience.adobe.com/platform"
      }}>{`Adobe Experience Platform`}</a>{` for the customer profiles where the `}<inlineCode parentName="p">{`Authenticated State = Ambiguous`}</inlineCode>{`.`}</p>
    <ol>
      <li parentName="ol">{`Select `}<strong parentName="li">{`Audiences`}</strong>{` from the left panel, followed by `}<strong parentName="li">{`Create audience`}</strong>{` and `}<strong parentName="li">{`Build rule`}</strong>{`.`}</li>
      <li parentName="ol">{`Select `}<strong parentName="li">{`Events`}</strong>{`, followed by `}<strong parentName="li">{`XDM Experience Event`}</strong>{` and `}<strong parentName="li">{`Identity Map`}</strong>{` and add the `}<strong parentName="li">{`Authenticated State`}</strong>{` element in the `}<strong parentName="li">{`Start building segment`}</strong>{` section.`}</li>
      <li parentName="ol">{`Select `}<strong parentName="li">{`Include Identity Map`}</strong>{` within email where `}<inlineCode parentName="li">{`Authenticated State`}</inlineCode>{` equals `}<inlineCode parentName="li">{`Ambiguous`}</inlineCode>{`.`}</li>
      <li parentName="ol">{`Set the name for this audience, for example "Users with email and authenticated state ambiguous".`}</li>
      <li parentName="ol">{`Select `}<strong parentName="li">{`Save`}</strong>{`.`}</li>
      <li parentName="ol">{`Once the audience is computed, you can see how many users qualify for this audience.`}</li>
    </ol>
    <p>{`For more details about segmentation in Adobe Experience Platform, see the `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/experience-platform/segmentation/ui/segment-builder.html"
      }}>{`Segment Builder user guide`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      